import React from "react";
import { TextField, useRecordContext } from "react-admin";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";

import { withDisabledIfCancelled } from "../helpers/withDisabled";
import { ORDER_ITEM_CANCELLED } from "../components/Constant";
import TextLinkField from "../components/Common/TextLinkField";
import { replaceImageSource } from "../helpers/withReplaceImageSource";

const OrderItemTextField = withDisabledIfCancelled(TextField);
const OrderItemTextLinkField = withDisabledIfCancelled(TextLinkField);

const Root = styled("span")(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginTop: -theme.spacing(0.5),
  marginBottom: -theme.spacing(0.5),
  width: 25,
  height: 25,
}));

const Comp = (props) => {
  const record = useRecordContext();
  const { disableLink, ...otherProps } = props;
  const { keyword, status } = record;

  if (status === ORDER_ITEM_CANCELLED) {
    return <OrderItemTextField {...otherProps} />;
  }

  return (
    <Root>
      <StyledAvatar
        alt="item"
        src={
          keyword && keyword.images.length && keyword.images.length > 0
            ? replaceImageSource(keyword.images[0].name)
            : ""
        }
      />
      {disableLink && <OrderItemTextField {...otherProps} />}
      {!disableLink && (
        <OrderItemTextLinkField
          {...otherProps}
          source="description"
          resourceName="orderItems"
          resourceKeyId="_id"
        />
      )}
    </Root>
  );
};

export default Comp;
